import { InputParameters } from "../InputParameters";
import { TextField } from "@mui/material";

import "./style.css";
import { NumericFormat } from 'react-number-format';

export interface InputDecimalProperties extends InputParameters<number | null> {
  allowNegative?: boolean;
  maxLength?: number;
  minLength?: number;
  decimal?: number;
  onChangeValue?: Function;
}

const NumberFormatCustom = (props: any) => {
  const { inputref, onChange, symbol, decimal, sufix, ...other } = props;
  const _props: any = { ...props };
  return (
    <NumericFormat
      {..._props}
      getInputRef={inputref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: other.name,
            value: values.value,
          },
        });
      }}
      decimalScale={decimal}
      fixedDecimalScale
      isNumericString={true}
      thousandSeparator={false}
      decimalSeparator=","
      prefix={symbol ? symbol + " " : ""}
      maxLength={_props.maxLength}
      minLength={_props.minLength}
    />
  );
};

const InputDecimal = (props: InputDecimalProperties) => {

  const _props: any = { ...props }


  return (
    <TextField
      fullWidth
      variant={"outlined"}
      size={"small"}
      {..._props}
      error={props.error ? props.error : false}
      InputProps={{
        inputComponent: NumberFormatCustom,
        endAdornment: props.sufix ? props.sufix : null,
        startAdornment: props.prefix ? props.prefix : null,
        inputProps: {

          decimal: props.decimal,
          maxLength: props.maxLength,
          minLength: props.minLength,
        },
      }}
      InputLabelProps={{
        shrink: true,
      }}
      sufix={props.sufix as any}
    />
  );
};

export { InputDecimal };
